import { modelLightweightArticle } from '@/models/content/article.js'

export const modelHeroCarousel = (data) => {
  return {
    slideDuration: data.hero.slideDuration,
    slideTransitionDuration: data.hero.slideTransitionDuration,
    overlayOpacity: data.hero.overlayOpacity,
    slides: data.hero.slides.map((slide) => {
      const article = modelLightweightArticle(slide.article)

      return {
        slug: article.fullSlug,
        showCategory: slide.showCategory,
        date: article._firstPublishedAt || article.createdAt,
        title: article.title,
        subtitle: article.subtitle,
        category: article.category,
        media: {
          image: slide.image,
          mobileImage: slide.mobileImage || null,
          videoUrl: slide.video?.src || null,
          mobileVideoUrl: slide.mobileVideo?.src || null
        }
      }
    })
  }
}
